// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import store from '@/store'
import i18n from '@/lang'

import '@/base'
import '@/api' // 导入api
import 'amfe-flexible' // 自适应布局
import '@/icons' // svg图标 <svg-icon icon-class="id"/>
import '@/errorLog'
import '@/permission'

// import VConsole from 'vconsole';
// const vConsole = new VConsole();

import * as filters from '@/filters' // global filters
// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import {
  Button,
  Popup,
  Tabbar,
  TabbarItem,
  NavBar,
  Icon,
  Swipe,
  SwipeItem,
  Field,
  Dialog,
  Toast, 
  Divider,
  Tab,
  Tabs,
  Pagination,
  Picker, 
  Loading,
  ImagePreview,
  NoticeBar,
  Empty, 
  Form,
  Uploader,
  Tag,
  TreeSelect,
  RadioGroup,
  Radio
} from 'vant'
Vue.use(Button)
  .use(Popup)
  .use(Tabbar)
  .use(TabbarItem)
  .use(NavBar)
  .use(Icon)
  .use(Swipe)
  .use(SwipeItem)
  .use(Field)
  .use(Dialog)
  .use(Toast)
  .use(Divider)
  .use(Tab)
  .use(Tabs)
  .use(Pagination)
  .use(Picker)
  .use(Loading)
  .use(ImagePreview)
  .use(NoticeBar)
  .use(Empty)
  .use(Form)
  .use(Uploader)
  .use(Tag)
  .use(TreeSelect)
  .use(RadioGroup)
  .use(Radio)
  
Vue.config.productionTip = false

Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = binding.value || '默认标题'
  }
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
